import classnames from 'classnames/bind';
import styles from './index.module.less';

const cx = classnames.bind(styles);

/*
  将简介渲染成li标签形式，具体渲染形式为下
  <ul>

  // 字符串
  <li>...</li>     

  // 数组字符串
    <li>
      <ul>          
        <li>...</li>
        <li>...</li>
      </ul>
    </li>
  </ul>
*/
export const Desc = (props: { desc: string | any[]; fatherUlClass?: string; sonUlClass?: string }) => {
  const { desc, fatherUlClass, sonUlClass } = props;

  const isDescArray = Array.isArray(desc);

  if (isDescArray) {
    return (
      <ul className={`${cx('father-ul')} ${fatherUlClass}`}>
        {desc.map((item, index) => {
          // 判断是否是互动游戏
          const isActivityGame = Array.isArray(item);

          // 是互动游戏特殊处理
          if (isActivityGame) {
            return <ActGameArrList key={index} actGameArr={item} sonUlClass={sonUlClass} />;
          }

          return <li key={index}>{item}</li>;
        })}
      </ul>
    );
  }

  return <>{desc}</>;
};

/*
   简介中输出三行两列的UI结构
  */
export const ActGameArrList = (props: { actGameArr: string[]; sonUlClass?: string }) => {
  const { actGameArr, sonUlClass } = props;
  const activityGameArr = actGameArr.filter(val => val !== '·');

  return (
    <ul className={`${cx('son-ul')} ${sonUlClass}`}>
      {activityGameArr.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
};
